
import { defineComponent, ref } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { useInvoicesModule } from '@/modules/invoices'
import { requiredRule } from '@/modules/validations'
import moment from 'moment'
import { useSessionModule } from '@/modules/session'
import { useRouter } from 'vue-router'
import { InvoicesRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'create-invoices-for-single-agreement',
    props: {
        agreementId: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { profile } = useSessionModule()
        const router = useRouter()
        const { createInvoiceForAgreement, setInvoicesAgreementFilter } = useInvoicesModule()

        const form = ref<QForm>()
        const issueDateModel = ref(moment().format('YYYY-MM-DD'))

        const sendRequest = async () => {
            const operatorId = profile.value?.id
            if (!operatorId) return
            await createInvoiceForAgreement({
                agreementId: props.agreementId,
                issueDate: moment(issueDateModel.value).format('YYYY-MM-DD'),
                operatorId: operatorId
            })
        }

        const goToInvoices = () => {
            setInvoicesAgreementFilter(props.agreementId)
            router.push({ name: InvoicesRouteNames.LIST, query: { page: '1' } })
        }

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Invoices were created for the agreement')
        )
            .then(goToInvoices)
            .finally(onDialogOK)

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            issueDateModel,
            onSubmit,
            form,
            requiredRule
        }
    }
})
